import { CloseIcon } from "../../../components/Icons";
import { GvPrimaryButton } from "../../../components";
import HospitalCard from "../../../components/HospitalCard/HospitalCard";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import { MODALS } from "../../../config/params";
/* eslint-disable max-len */
import React from "react";
import { useModal } from "../../../context/ModalContext";
import { useUpdateLocationStore } from "../../../hooks/redux-hooks/updateLocation-store/updateLocation-store";
import { userActivityLogger } from "../../../utils/mixpanel";

const UpdateHospitalPreviewModal = () => {
  const { closeModal, openModal } = useModal();
  const { locationSelected } = useUpdateLocationStore();


  const handleUpdateHospital = () => {
    userActivityLogger(MIXPANEL_EVENTS.UPDATE_HOSPITAL_CLICK, { new_hospital: locationSelected[0].locationName });
    openModal(MODALS.UPDATE_HOSPITAL);
  };
  const handleCloseIcon = () =>{
    closeModal();
  };


  return (
    <div className="relative flex flex-col justify-between h-[95%] gap-4 p-2">

      <div>
        <div onClick={handleCloseIcon} className="flex justify-end cursor-pointer">
          <CloseIcon width = {20} height = {20} />
        </div>
        <div className="text-xl font-semibold text-center geograph-regular">
          Change Home Hospital
        </div>
      </div>

      <div className="h-[80%] overflow-y-auto pe-2">
        {locationSelected && <HospitalCard hospitalDetails={locationSelected[0]} isDisplayedInModal={true} displayedModalType="previewModal" />}
      </div>

      <div className="w-full">
        <GvPrimaryButton
          onClick={handleUpdateHospital}
          className="!h-[2.3rem]"
          type="button">
          <div className="normal-case font-semibold text-xs text-center">Update as Home Hospital</div>
        </GvPrimaryButton>
      </div>
    </div>
  );
};

export default UpdateHospitalPreviewModal;
